export default function Shipping({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      className={className}
    >
      <path
        d="M13.7422 24.5334V13.334"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      ></path>
      <path
        d="M23.6023 8.16992L13.7698 13.3337L3.88672 8.37805"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      ></path>
      <path
        d="M13.5786 3.0293L23.6023 8.17055V19.3362L13.7698 24.5337L3.88672 19.3587V8.37867L13.5786 3.0293Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      ></path>
      <path
        d="M9.02344 5.56055L18.9516 10.6174V17.2662"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      ></path>
    </svg>
  );
}
